import {
    WarningMailTipModeratedMessage,
    WarningMailTipModeratedMessageMultiple,
} from '../strings.locstring.json';
import loc from 'owa-localize';
import {
    InfoBarMessageViewState,
    InfoBarMessageRank,
    InfoBarMessageSource,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { getGenericMessageElementAndParts } from './getGenericMessageParts';
import { MailTipsCategory } from '../datapoints';

/**
 * @param recipients is the list of recipients
 * @param onRemoveRecipientsClick callback when remove is triggered from mailTip
 * @returns InfoBarMessageViewState for recipients whose mailboxes are moderated.
 * @returns null if no recipient mailboxes are moderated.
 */
export default (
    recipients: EmailAddressWrapper[],
    onRemoveRecipientsClick: (recipients: EmailAddressWrapper[]) => void
): InfoBarMessageViewState => {
    if (!recipients.length) {
        return null;
    }
    const [messageElement, messageParts] = getGenericMessageElementAndParts(
        recipients,
        loc(WarningMailTipModeratedMessage),
        loc(WarningMailTipModeratedMessageMultiple),
        onRemoveRecipientsClick,
        MailTipsCategory.IsModerated
    );
    return {
        key: 'IsModerated',
        messageElement,
        messageParts,
        rank: InfoBarMessageRank.Info,
        source: InfoBarMessageSource.Compose,
    };
};
